import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { userApi } from "shared/api/client/orval";
import { normalizeUserRole } from "shared/auth/constants/roles";
import { getAuthCookieAttributes } from "shared/auth/utils/cookieUtils";

export const useTokenProcessing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const googleToken = params.get("Token");
    if (googleToken) {
      userApi
        .getApiUserRecreateToken({ token: googleToken })
        .then((res) => res.data)
        .then((data: any) => {
          const userToken = data.token;
          const userId = data.id;
          const userEmail = data.email || data.user_email || "";
          const userFirstName = data.first_name || data.firstName || "";
          const userLastName = data.last_name || data.lastName || "";
          const userIsVerified = data.user_is_verified;
          const userRole = data.user_role;
          const authCookieAttributes = getAuthCookieAttributes();
          document.cookie = `userToken=${userToken}; ${authCookieAttributes}`;
          document.cookie = `userId=${userId}; ${authCookieAttributes}`;
          document.cookie = `userEmail=${userEmail}; ${authCookieAttributes}`;
          document.cookie = `userFirstName=${userFirstName}; ${authCookieAttributes}`;
          document.cookie = `userLastName=${userLastName}; ${authCookieAttributes}`;
          document.cookie = `userIsVerified=${userIsVerified}; ${authCookieAttributes}`;
          document.cookie = `userRole=${userRole}; ${authCookieAttributes}`;

          const isMobileDevice =
            window.matchMedia("(pointer: coarse)").matches ||
            "ontouchstart" in window;
          const normalizedRole = normalizeUserRole(userRole);
          const desktopRoute =
            normalizedRole === "USER"
              ? "/home"
              : normalizedRole === "CURATOR"
                ? "/home/movie-review"
                : "/home/library";
          navigate(isMobileDevice ? "/mobile/pair_headset" : desktopRoute);
        })
        .catch((error) => console.error("Error:", error));
    }
  }, [navigate]);

  return null;
};
